import axios from 'axios';
import { z } from 'zod';

import { strictQuery } from 'utils/strict-query';

import { QuestionnaireInstanceZod } from 'types/zod/questionnaire-instance';

const AdminApi = {
    getQInstances: strictQuery({
        In: z.string(),
        Out: QuestionnaireInstanceZod.array(),
        handler: (awsid: string) => axios.get('/admin/qinstances', { params: { awsid } }),
    }),

    deleteUser: strictQuery({
        In: z.object({ awsid: z.string(), password: z.string() }),
        Out: z.any(),
        handler: ({ awsid, password }: { awsid: string; password: string }) =>
            axios.delete(`/users/${awsid}`, { params: { password } }),
    }),

    generateDocument: strictQuery({
        In: z.object({ type: z.string(), body: z.any() }),
        Out: z.any(),
        handler: ({ type, body }) => axios.post('/admin/documents/generate', body, { params: { type } }),
    }),
};

export default AdminApi;
